import * as React from "react";

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33.514}
      height={34.197}
      viewBox="0 0 33.514 34.197"
      {...props}
    >
      <path data-name="Path 6" d="M0 0h33.514v34.2H0z" fill="none" />
      <path
        data-name="Path 7"
        d="M21.715.628H11.8v3.077h9.916zm-6.61 20h3.305v-9.229h-3.305zm13.27-10.171l2.347-2.185a17.686 17.686 0 00-2.33-2.17l-2.347 2.189a15.505 15.505 0 00-9.288-3.047c-8.213 0-14.873 6.201-14.873 13.849s6.643 13.849 14.873 13.849 14.873-6.2 14.873-13.849a13.213 13.213 0 00-3.256-8.632zm-11.618 19.4c-6.4 0-11.568-4.816-11.568-10.771S10.362 8.322 16.757 8.322s11.568 4.816 11.568 10.771-5.172 10.771-11.568 10.771z"
      />
    </svg>
  );
}

export default SvgComponent;
